import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SplashScreen() {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      const username = localStorage.getItem('username');
      navigate(username ? '/dashboard' : '/login');
    }, 2800);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #EBF5FB 0%, #F4F8FB 40%, #EDF7F4 100%)',
      position: 'relative',
      gap: '32px',
    }}>
      {/* Dot-grid overlay */}
      <div style={{
        position: 'fixed', inset: 0,
        backgroundImage: 'radial-gradient(rgba(14,165,160,0.11) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
        pointerEvents: 'none',
        zIndex: 0,
      }} />

      <div style={{ position: 'relative', zIndex: 1, animation: 'splashFade 0.8s ease forwards', opacity: 0 }}>
        <img src="/logo.png" alt="Cytometrix" style={{
          maxWidth: 280,
        }} />
      </div>

      <div style={{
        position: 'relative', zIndex: 1,
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12,
        animation: 'splashFade 0.8s ease 0.4s forwards', opacity: 0,
      }}>
        <div style={{
          width: 40, height: 40,
          border: '3px solid rgba(0,0,0,0.10)',
          borderTopColor: '#3FA9F5',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <p style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '0.82rem',
          color: 'rgba(0,0,0,0.4)',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
        }}>
          Initializing Clinical System
        </p>
      </div>

      <style>{`
        @keyframes splashFade {
          to { opacity: 1; }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
